import React from 'react';
import styles from './BreadcrumbItem.scss';
export var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var active = _ref.active,
      dataTest = _ref.dataTest,
      href = _ref.href,
      children = _ref.children,
      onClick = _ref.onClick;

  var handleClick = function handleClick(event) {
    if (!href || href === '#') {
      event.preventDefault();
    }

    if (onClick) {
      onClick(event);
    }
  };

  return React.createElement("li", {
    className: styles.breadcrumbItem,
    "aria-current": active ? 'page' : undefined,
    "data-test": dataTest
  }, active ? React.createElement("span", null, children) : React.createElement("a", {
    onClick: handleClick,
    href: href
  }, children));
};
BreadcrumbItem.defaultProps = {
  active: false
};
BreadcrumbItem.displayName = 'BreadcrumbItem';